// Testing analytics: Download this extension and monitor changes in your developer console
// https://chrome.google.com/webstore/detail/google-analytics-debugger/jnkmfdileelhofjcijamephohjechhna?hl=en

import ReactGA from 'react-ga4';

type LogAnalyticsPageView = {
  title: string;
  page?: string;
};

type LogAnalyticsEvent = {
  category: 'success' | 'error' | 'interaction';
  action: string;
  label?: string;
  value?: number;
  nonInteraction?: boolean;
};

/**
 * Logs a page view event in Google Analytics.
 *
 * NOTE: Page views are automatically collected by the system so this should not be used very often.
 * @param {string} pageViewData.title - Required: The title of the page or view
 * @param {string} pageViewData.page - The page url. Automatically defaults to  `window.location.pathname`
 */
export function logAnalyticsPageView(pageViewData: LogAnalyticsPageView): void {
  const page = pageViewData.page ? pageViewData.page : window.location.pathname;

  ReactGA.send({
    hitType: 'pageview',
    title: pageViewData.title,
    page,
  });
}

/**
 * Logs an analytics event in Google Analytics.
 *
 * Recommended Events: https://developers.google.com/tag-platform/gtagjs/reference/events
 * @param {string} eventData.category - Required: Event category for quick grouping. IE: error, success, intereaction, etc
 * @param {string} eventData.action - Required: Event action name. Must be less than 40 characters! IE: newAccountFormError
 * @param {string} eventData.label - Event label used for further grouping
 * @param {number} eventData.value - Value data you want logged with the event. IE: Amount in a transaction
 * @param {boolean} eventData.nonInteraction - Was the event triggered by the user interacting with the app or not?
 */
export function logAnalyticsEvent(eventData: LogAnalyticsEvent): void {
  ReactGA.event(eventData);
}
